import { sort } from 'ramda';

import { EMediaType, TMedia, TPhotoMedia } from '../../../../../shared/components/Carousel/types';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { IOfferPhoto } from '../../types/offer';

export const media: TComputedPropMapper<TMedia[]> = ({ offer }) => {
  const media: TMedia[] = [];

  if (offer.photos?.length) {
    const photos: TPhotoMedia[] = sort<IOfferPhoto>(
      (a, b) => Number(b.isDefault) - Number(a.isDefault),
      offer.photos || [],
    ).map(photo => ({
      type: photo.isLayout ? EMediaType.Layout : EMediaType.Photo,
      src: photo.thumbnail2Url,
    }));

    media.push(...photos);
  }

  return media;
};
